import React, { useState, useEffect } from "react";
import {
    Button,
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    TextField,
    TableFooter,
    FormControl,
    InputLabel,
    Select,
    MenuItem,RadioGroup,Radio,FormControlLabel,InputAdornment,Dialog,DialogTitle,DialogContent,DialogActions
} from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import axios from "axios";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import LayoutUserHeader from '../components/LayoutUserHeader';
import { useParams, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const AddPurchaseInvoice = ({ invoiceId = null }) => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [registrationData, setRegistrationData] = useState(null);
    const [invoiceNo, setInvoiceNo] = useState('');
    const [invoiceDate, setInvoiceDate] = useState(dayjs());
    const [productState, setProductState] = useState('');
    const [productStateCode, setProductStateCode] = useState('');
    const [stateList, setStateList] = useState([]);
    const [grNo, setGrNo] = useState('');
    const [transportDate, setTransportDate] = useState(dayjs());
    const [vehicleNo, setVehicleNo] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedConsignee, setSelectedConsignee] = useState(null);
    const [transportationMode, setTransportationMode] = useState('');
    const [transporterName, setTransporterName] = useState('');
     const [placeOfSupply, setPlaceOfSupply] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [customerAddress, setCustomerAddress] = useState('');
    const [gstin, setGstin] = useState('');
    const [loadingConsignees, setLoadingConsignees] = useState(false);
    const [customerState, setCustomerState] = useState('');
    const [customerStateCode, setCustomerStateCode] = useState('');
    const [productList, setProductList] = useState([]);
    const [personType, setPersonType] = useState("Registered");
    const [prefix, setPrefix] = useState(''); 
    const today = dayjs();
    const currentYear = today.month() >= 3 ? today.year() : today.year() - 1; // Financial year starts in April
    const financialYearStart = dayjs(`${currentYear}-04-01`);
    const financialYearEnd = dayjs(`${currentYear + 1}-03-31`);
    const [consigneeList, setConsigneeList] = useState([]);
    const [cgst, setCgst] = useState('');
const [sgst, setSgst] = useState('');
const [isCgstLocked, setIsCgstLocked] = useState(false);
const [isSgstLocked, setIsSgstLocked] = useState(false);
    const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  
// Updated handleConsigneeSelect with proper stateCode formatting and personType handling

const handleConsigneeSelect = (consignee) => {
  setCustomerName(consignee.name || '');

  const isUnregistered = consignee.gstin === "URP" || consignee.gstin === "";

  setPersonType(isUnregistered ? "Unregistered" : "Registered");

  setGstin(isUnregistered ? "URP" : consignee.gstin || '');
  setCustomerAddress(consignee.address || '');
  setCustomerState(consignee.state || '');

  const formattedStateCode =
    consignee.stateCode !== undefined && consignee.stateCode !== null
      ? consignee.stateCode.toString().padStart(2, '0')
      : '';
  setCustomerStateCode(formattedStateCode);

  setOpenDialog(false); // Close dialog

  setRows((prevRows) => {
  if (isUnregistered) {
    // For URP + no product chosen, set taxes to zero
    return prevRows.map(row => {
      if (!row.productId) {
        return {
          ...row,
          CGSTPercentage: 0,
          SGSTPercentage: 0,
          IGSTPercentage: 0,
          CGSTAmount: "0.00",
          SGSTAmount: "0.00",
          IGSTAmount: "0.00",
          gstPercentage: 0,
          gstAmount: "0.00",
          taxableAmount: "0.00",
          totalAmount: "0.00"
        };
      }
      // Just return the existing product row unchanged for URP
      return row;
    });
  } else {
    // For Registered person: don't recalc, just keep row values as-is
    return prevRows;
  }
});

};

    const [localReceiverData, setLocalReceiverData] = useState({
      firstName: '',
      address: '',
      gstin: '',
      stateName: '',
      stateCode: ''
    });
    const [rows, setRows] = useState([
        {
            id: uuidv4(),
            productId: "",
            hsn: "",
            unit: "",
            qty: "",
            rate: "",
            amount: "",
            otherCharges: "",   
            gstPercentage: "",
            gstAmount: "",
            totalAmount: "",
            CGSTAmount: "",
            SGSTAmount: "",
            CGSTPercentage: "",
            SGSTPercentage: "",
            IGSTAmount: "",
            IGSTPercentage: "",
            taxableAmount: "0.00"
        }
    ]);

 const isSameState = String(productStateCode || '').trim().padStart(2, '0') === String(customerStateCode || '').trim().padStart(2, '0');
 const gstNumber = localStorage.getItem("gstNumber");

 
useEffect(() => {
  if (registrationData?.prefix) {
    setPrefix(registrationData.prefix);
  }
}, [registrationData]);

useEffect(() => {
  if (registrationData?.stateName) {
    setPlaceOfSupply(registrationData.stateName);
  }
}, [registrationData]);

useEffect(() => {
  const gstNumber = localStorage.getItem("gstNumber");
  if (!gstNumber) return;

  const fetchRegistrationData = async () => {
    try {
      const token = localStorage.getItem("token");

const response = await axios.get(
  `${BASE_URL}/Registration/GetDetailsByGstNumber/${gstNumber}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      if (response.data?.data) {
        const data = response.data.data;
        setRegistrationData(data);
        console.log(data);

        if (data.stateName && data.stateCode) {
          const formattedCode = data.stateCode < 10 ? `0${data.stateCode}` : `${data.stateCode}`;
          setProductState(data.stateName);
          setProductStateCode(formattedCode);
          setCustomerState(data.stateName);
          setCustomerStateCode(formattedCode);
        }
      }
    } catch (error) {
      console.error("Failed to fetch registration data:", error);
    }
  };
  fetchRegistrationData();
}, []);


const handleCgstChange = (e) => {
  const value = e.target.value;
  setCgst(value);
  setSgst(value);
  setIsSgstLocked(true);
  setIsCgstLocked(false);
};

const handleSgstChange = (e) => {
  const value = e.target.value;
  setSgst(value);
  setCgst(value);
  setIsCgstLocked(true);
  setIsSgstLocked(false);
};

const handleClear = () => {
  setCgst('');
  setSgst('');
  setIsCgstLocked(false);
  setIsSgstLocked(false);
};

const handleGstinChange = (value, setGstin, personType) => {
  const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const upperValue = value.toUpperCase();

  if (upperValue.length > 15) {
    alert("GST Number should not exceed 15 characters");
    return;
  }

  if (upperValue.length === 15 && !gstinRegex.test(upperValue)) {
    alert("Invalid GSTIN format");
    setGstin("");
    return;
  }

  setGstin(upperValue);
};

const panNumber = gstNumber.substring(2, 12);

useEffect(() => {
  const fetchStates = async () => {
    try {
      const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/State/GetAllStates`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      setStateList(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching states:", err);
    }
  };
  fetchStates();
}, []);

useEffect(() => {
  if (!gstNumber) return;

  const fetchProducts = async () => {
    try {
      const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/ProductUnitHsnMapping/GetProductDetailsBasedOnGST`, {
  params: { gstNumber },
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      setProductList(res.data?.data || []);
    } catch (err) {
      console.error("Product fetch error:", err);
    }
  };

const fetchInvoice = async () => {
  if (!id) return;

  try {
    const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/PurchaseInvoice/Get/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

    const data = res.data?.data;
    if (!data) return;

    // ====== Header fields ======
    setInvoiceNo(data.InvoiceNumber);
    setInvoiceDate(dayjs(data.InvoiceDate));
    setProductState(data.StateId);
    setProductStateCode(data.StateCode);
    setGrNo(data.GRNumber);
    setTransportDate(dayjs(data.TransportDate));
    setVehicleNo(data.VehicleNumber);
    setTransportationMode(data.TranspotationMode);
    setTransporterName(data.TransporterName);
    setCustomerName(data.CustomerName);
    setCustomerAddress(data.CustomerAddress);
    setGstin(data.CustomerGSTNumber);
    setCustomerState(data.CustomerStateId);
    setCustomerStateCode(data.CustomerStateCode);
    setPersonType(data.SupplierType);

    const formattedProducts = data.Products.map((p) => {
  const qty = parseFloat(p.Quantity?.$numberDecimal || p.Quantity) || 0;
  const rate = parseFloat(p.Rate?.$numberDecimal || p.Rate) || 0;
  const otherCharges = parseFloat(p.OtherCharges || 0);
  const cess = parseFloat(p.Cess || 0);

  const cgstPercent = parseFloat(p.CGSTPercentage || 0);
  const sgstPercent = parseFloat(p.SGSTPercentage || 0);
  const igstPercent = parseFloat(p.IGSTPercentage || 0);

  const isManualRow = !p.ProductId;

  // ====== Base Amount (without other charges) ======
  let baseAmount;
  if (isManualRow) {
    baseAmount = parseFloat(p.Amount) || 0;
  } else {
    baseAmount = qty * rate;
  }

  // ====== Taxable Amount (condition on SupplierType) ======
  let taxableAmount;
  if (data.SupplierType === "Registered") {
    taxableAmount = baseAmount + otherCharges;
  } else {
    taxableAmount = baseAmount; // URP → exclude other charges
  }

  // ====== GST Amounts ======
  const CGSTAmountCalc = (taxableAmount * cgstPercent) / 100;
  const SGSTAmountCalc = (taxableAmount * sgstPercent) / 100;
  const IGSTAmountCalc = (taxableAmount * igstPercent) / 100;
  const gstAmountCalc = CGSTAmountCalc + SGSTAmountCalc + IGSTAmountCalc;

  // ====== Total (URP otherCharges still add AFTER gst) ======
  const totalAmount =
    taxableAmount + gstAmountCalc + cess + (data.SupplierType === "Registered" ? 0 : otherCharges);

  return {
    id: uuidv4(),
    productId: p.ProductId || "",
    hsn: p.HSNCode || "",
    qty,
    rate,
    unit: p.Unit || "",
    amount: baseAmount.toFixed(2),
    gstPercentage: (cgstPercent + sgstPercent + igstPercent).toFixed(2),
    taxableAmount: taxableAmount.toFixed(2),
    gstAmount: gstAmountCalc.toFixed(2),
    CGSTAmount: CGSTAmountCalc.toFixed(2),
    SGSTAmount: SGSTAmountCalc.toFixed(2),
    IGSTAmount: IGSTAmountCalc.toFixed(2),
    CGSTPercentage: cgstPercent.toFixed(2),
    SGSTPercentage: sgstPercent.toFixed(2),
    IGSTPercentage: igstPercent.toFixed(2),
    otherCharges: otherCharges.toFixed(2),
    cess: cess.toFixed(2),
    totalAmount: totalAmount.toFixed(2),
  };
});

    setRows(formattedProducts);
  } catch (err) {
    console.error("Error loading invoice:", err);
  }
};

  fetchProducts();
  fetchInvoice();
}, [id]);

const handleBlur = () => {
  if (vehicleNo.length >= 4) {
    const prefix = vehicleNo.substring(0, 4);
    const regex = /^[A-Za-z]{2}[0-9]{2}$/;

    if (!regex.test(prefix)) {
      alert('Invalid Vehicle Number format:\n- First 2 characters must be alphabets\n- Next 2 must be digits');
      setVehicleNo('');
    }
  }
};

useEffect(() => {
  const gstNumber = localStorage.getItem("gstNumber");

  if (id || !gstNumber || personType === "Registered") return;

  const fetchInvoiceCount = async () => {
    try {
      const token = localStorage.getItem("token");

const response = await axios.get(`${BASE_URL}/PurchaseInvoice/List`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      const allInvoices = response.data?.data || [];

      const filteredInvoices = allInvoices.filter(
        (invoice) =>
          invoice?.GSTNumber?.toUpperCase().trim() === gstNumber &&
          invoice?.SupplierType === "Unregistered"
      );

      const nextSerial = (filteredInvoices.length + 1).toString().padStart(2, "0");
      const generatedInvoiceNo = `${nextSerial}`;
      setInvoiceNo(generatedInvoiceNo);
    } catch (error) {
      console.error("Failed to fetch invoices:", error);
    }
  };

  fetchInvoiceCount();
}, [personType, id]);

const handleSave = async () => {
  try {
    const payload = {
      name: localReceiverData.firstName,
      address: localReceiverData.address,
      gstin: localReceiverData.gstin,
      state: localReceiverData.stateName,
      stateCode: Number(localReceiverData.stateCode),
      usergstin: localStorage.getItem("gstNumber")
    };

    console.log(payload);
    const token = localStorage.getItem("token");

const res = await axios.post(
  `${BASE_URL}/ConsigneePurchaseMaster/Add`,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
    alert('Added To Master Data');

  } catch (err) {
    alert('Save to Consignee Master failed');
    console.error('Consignee save error:', err);
  }
};

const handleProductChange = async (rowId, selectedProductId) => {
  const updatedRows = [];

  for (const row of rows) {
    if (row.id !== rowId) {
      updatedRows.push(row);
      continue;
    }

    const isManualRow = !selectedProductId && personType === "Registered";

    // 🔹 Case 1: Manual row
    if (isManualRow) {
      const taxableAmountManual = parseFloat(row.taxableAmount) || parseFloat(row.amount) || 0;
      const otherCharges = parseFloat(row.otherCharges || 0);
      const cess = parseFloat(row.cess || 0);

      const gstBase = taxableAmountManual + otherCharges;

      const cgstPercent = parseFloat(row.CGSTPercentage || 0);
      const sgstPercent = parseFloat(row.SGSTPercentage || 0);
      const igstPercent = parseFloat(row.IGSTPercentage || 0);

      const cgstAmount = (gstBase * cgstPercent) / 100;
      const sgstAmount = (gstBase * sgstPercent) / 100;
      const igstAmount = (gstBase * igstPercent) / 100;
      const gstAmount = cgstAmount + sgstAmount + igstAmount;

      const totalAmount = gstBase + gstAmount + cess;

      updatedRows.push({
        ...row,
        productId: "",
        amount: taxableAmountManual.toFixed(2),
        taxableAmount: taxableAmountManual.toFixed(2),
        gstAmount: gstAmount.toFixed(2),
        CGSTAmount: cgstAmount.toFixed(2),
        SGSTAmount: sgstAmount.toFixed(2),
        IGSTAmount: igstAmount.toFixed(2),
        totalAmount: totalAmount.toFixed(2),
      });

      continue;
    }

    // 🔹 Case 2: Product selected
    try {
      const token = localStorage.getItem("token");

const res = await axios.get(
  `${BASE_URL}/ProductUnitHsnMapping/GetHsnUnitGstById/${selectedProductId}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      const mapping = res.data?.data;

      if (!mapping) {
        toast.warn(`No mapping found for product ID: ${selectedProductId}`);
        updatedRows.push({ ...row, productId: selectedProductId });
        continue;
      }

      const qty = parseFloat(row.qty) || 0;
      const rate = parseFloat(row.rate) || 0;
      const otherCharges = parseFloat(row.otherCharges || 0);
      const cess = parseFloat(row.cess || 0);

      const baseAmount = qty * rate;

      // ---------------------------
      // 1️⃣ Taxable & GST Base
      // ---------------------------
      let taxableAmount, gstBase;

      if (personType === "Unregistered") {
        taxableAmount = baseAmount;
        gstBase = taxableAmount; // URP: other charges not included in GST base
      } else {
        taxableAmount = baseAmount + otherCharges;
        gstBase = taxableAmount; // Registered: include other charges in GST base
      }

      // ---------------------------
      // 2️⃣ GST Percentages
      // ---------------------------
      const gstPercentage = parseFloat(mapping?.GstPercentage?.PercentageValue || 0);
      const sameState =
        productStateCode && customerStateCode && productStateCode === customerStateCode;

      const CGSTPercent = sameState ? gstPercentage / 2 : 0;
      const SGSTPercent = sameState ? gstPercentage / 2 : 0;
      const IGSTPercent = sameState ? 0 : gstPercentage;

      // ---------------------------
      // 3️⃣ GST Amounts
      // ---------------------------
      const cgstAmount = (gstBase * CGSTPercent) / 100;
      const sgstAmount = (gstBase * SGSTPercent) / 100;
      const igstAmount = (gstBase * IGSTPercent) / 100;
      const gstAmount = cgstAmount + sgstAmount + igstAmount;

      // ---------------------------
      // 4️⃣ Total Amount
      // ---------------------------
      const totalAmount =
        personType === "Unregistered"
          ? taxableAmount + gstAmount + otherCharges + cess
          : gstBase + gstAmount + cess;

      // ---------------------------
      // 5️⃣ Push Updated Row
      // ---------------------------
      updatedRows.push({
        ...row,
        productId: selectedProductId,
        hsn: mapping?.HSNCode || "",
        unit: mapping?.Unit?.UnitName || "",
        gstPercentage,
        qty,
        rate: rate.toFixed(2),
        amount: baseAmount.toFixed(2),
        taxableAmount: taxableAmount.toFixed(2),
        gstAmount: gstAmount.toFixed(2),
        CGSTAmount: cgstAmount.toFixed(2),
        SGSTAmount: sgstAmount.toFixed(2),
        IGSTAmount: igstAmount.toFixed(2),
        CGSTPercentage: CGSTPercent.toFixed(2),
        SGSTPercentage: SGSTPercent.toFixed(2),
        IGSTPercentage: IGSTPercent.toFixed(2),
        otherCharges: otherCharges.toFixed(2),
        cess: cess.toFixed(2),
        totalAmount: totalAmount.toFixed(2),
        __lockedBy: sameState ? "CGST" : "IGST",
      });

      toast.success(`Mapping applied for product`);
    } catch (err) {
      console.error("Error fetching product data:", err);
      toast.error(`Failed to fetch mapping for '${selectedProductId}'`);
      updatedRows.push(row);
    }
  }

  setRows(updatedRows);
};


const handleInputChange = (id, field, value) => {
  const toNum = (v) => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  };

  const updatedRows = rows.map((row) => {
    if (row.id !== id) return row;

    const updatedRow = { ...row, [field]: value };

    // parse helper that respects the currently edited field's live value
    const parseNum = (key) =>
      key === field ? toNum(value) : toNum(updatedRow[key]);

    const qty = parseNum("qty");
    const rate = parseNum("rate");
    const otherCharges = parseNum("otherCharges");
    const cessVal = parseNum("cess");

    let gstPercent = parseNum("gstPercentage");
    let cgstPercent = parseNum("CGSTPercentage");
    let sgstPercent = parseNum("SGSTPercentage");
    let igstPercent = parseNum("IGSTPercentage");

    // manual row = no product selected (works for Registered & Unregistered)
    const isManualRow = !updatedRow.productId;

    const sameState =
      productStateCode &&
      customerStateCode &&
      productStateCode === customerStateCode;

    // ====== Base Amount (EXCLUDES other charges) ======
    let baseAmount;
    if (isManualRow) {
      // User types base into "Taxable Amount" cell for manual rows.
      if (field === "taxableAmount") {
        baseAmount = toNum(value);
        updatedRow.amount = baseAmount.toFixed(2); // persist manual base in amount
      } else {
        baseAmount = toNum(updatedRow.amount); // always read manual base from 'amount'
      }
    } else {
      baseAmount = qty * rate;
      updatedRow.amount = baseAmount.toFixed(2);
    }

    // ====== Taxable (Registered includes otherCharges, URP excludes) ======
    let taxableAmount;
    if (personType === "Registered") {
      taxableAmount = baseAmount + otherCharges;
    } else {
      taxableAmount = baseAmount; // URP: otherCharges not part of GST base
    }
    updatedRow.taxableAmount = taxableAmount;

    // ====== GST Percentages (mutual exclusivity rules) ======
    const setSplit = () => {
      updatedRow.CGSTPercentage = cgstPercent;
      updatedRow.SGSTPercentage = sgstPercent;
      updatedRow.IGSTPercentage = 0;
    };
    const setIGST = (p) => {
      updatedRow.IGSTPercentage = p;
      updatedRow.CGSTPercentage = 0;
      updatedRow.SGSTPercentage = 0;
    };

    if (sameState) {
      if (field === "CGSTPercentage") {
        cgstPercent = toNum(value);
        sgstPercent = cgstPercent; // mirror
        setSplit();
      } else if (field === "SGSTPercentage") {
        sgstPercent = toNum(value);
        cgstPercent = sgstPercent; // mirror
        setSplit();
      } else if (field === "gstPercentage") {
        gstPercent = toNum(value);
        cgstPercent = gstPercent / 2;
        sgstPercent = gstPercent / 2;
        setSplit();
      } else {
        // default split if only gstPercentage present
        if (!cgstPercent && !sgstPercent && gstPercent) {
          cgstPercent = gstPercent / 2;
          sgstPercent = gstPercent / 2;
        }
        setSplit();
      }
    } else {
      if (field === "IGSTPercentage") {
        igstPercent = toNum(value);
        setIGST(igstPercent);
      } else if (field === "gstPercentage") {
        igstPercent = toNum(value);
        setIGST(igstPercent);
      } else {
        setIGST(igstPercent || gstPercent || 0);
      }
    }

    // ====== GST Amounts (on Taxable) ======
    const cgstAmt =
      (taxableAmount * toNum(updatedRow.CGSTPercentage)) / 100;
    const sgstAmt =
      (taxableAmount * toNum(updatedRow.SGSTPercentage)) / 100;
    const igstAmt =
      (taxableAmount * toNum(updatedRow.IGSTPercentage)) / 100;

    const gstAmt = cgstAmt + sgstAmt + igstAmt;

    // ====== Total ======
    const totalAmount = baseAmount + otherCharges + gstAmt + cessVal;

    // ====== Assign back (rounding) ======
    updatedRow.CGSTAmount = cgstAmt.toFixed(2);
    updatedRow.SGSTAmount = sgstAmt.toFixed(2);
    updatedRow.IGSTAmount = igstAmt.toFixed(2);
    updatedRow.gstAmount = gstAmt.toFixed(2);
    updatedRow.totalAmount = totalAmount.toFixed(2);

    return updatedRow;
  });

  setRows(updatedRows);
};



const addRow = () => {
  setRows([
    ...rows,
    {
      id: uuidv4(),
      productId: "",
      hsn: "",
      unit: "",
      qty: "",
      rate: "",
      amount: "",
      gstPercentage: 0,
      gstAmount: 0,
      CGSTAmount: 0,
      SGSTAmount: 0,
      IGSTAmount: 0,
      CGSTPercentage: 0,
      SGSTPercentage: 0,
      IGSTPercentage: 0,
      otherCharges: "0.00",
      cess: "0.00",
      totalAmount: "0.00",
      taxableAmount: ""
    }
  ]);
};

    const removeRow = (id) => {
        if (rows.length === 1) return;
        setRows(rows.filter((row) => row.id !== id));
    };

const calculateTotals = () => {
  let totalQty = 0;
  let totalAmount = 0;
  let totalGstAmount = 0;
  let totalOtherCharges = 0;
  let totalCess = 0;
  let grandTotal = 0;

  rows.forEach(row => {
    totalQty += parseFloat(row.qty) || 0;
    totalAmount += parseFloat(row.amount) || 0;

    // ✅ Sum GST components
    totalGstAmount +=
      parseFloat(row.CGSTAmount || 0) +
      parseFloat(row.SGSTAmount || 0) +
      parseFloat(row.IGSTAmount || 0);

    totalOtherCharges += parseFloat(row.otherCharges) || 0;
    totalCess += parseFloat(row.cess) || 0;
    grandTotal += parseFloat(row.totalAmount) || 0;
  });

  return {
    totalQty: totalQty.toFixed(2),
    totalAmount: totalAmount.toFixed(2),
    totalGstAmount: totalGstAmount.toFixed(2),
    totalOtherCharges: totalOtherCharges.toFixed(2),
    totalCess: totalCess.toFixed(2),
    grandTotal: grandTotal.toFixed(2)
  };
};


const { totalQty, totalAmount, totalGstAmount, totalOtherCharges, totalCess, grandTotal } = calculateTotals();

    const convertNumberToWords = (amount) => {
    const numericValue = parseFloat(amount);
    if (isNaN(numericValue)) return "";

    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const places = ['', 'Thousand', 'Lakh', 'Crore'];

    const getWord = (n) => {
        let word = '';
        if (n > 99) {
            word += units[Math.floor(n / 100)] + ' Hundred ';
            n %= 100;
        }
        if (n > 19) {
            word += tens[Math.floor(n / 10)] + ' ';
            n %= 10;
        } else if (n >= 10) {
            word += teens[n - 10] + ' ';
            n = 0;
        }
        if (n > 0) {
            word += units[n] + ' ';
        }
        return word;
    };

    const numberToIndianWords = (num) => {
        if (num === 0) return 'Zero';

        let str = '';
        let parts = ['', '', '', ''];
        parts[0] = num % 1000; // units
        parts[1] = Math.floor((num % 100000) / 1000); // thousands
        parts[2] = Math.floor((num % 10000000) / 100000); // lakhs
        parts[3] = Math.floor(num / 10000000); // crores

        for (let i = 3; i >= 0; i--) {
            if (parts[i]) {
                str += getWord(parts[i]) + places[i] + ' ';
            }
        }

        return str.trim();
    };

    const [whole, fraction] = numericValue.toFixed(2).split('.');
    let result = numberToIndianWords(Number(whole)).toUpperCase();

    if (Number(fraction) > 0) {
        result += ` AND ${numberToIndianWords(Number(fraction)).toUpperCase()} PAISE`;
    }

    return result + " RUPEES ONLY";
};

   const handleSubmit = async () => {
  try {
    // Check for duplicate invoice number
    const token = localStorage.getItem("token");

const existingInvoices = await axios.get(`${BASE_URL}/PurchaseInvoice/List`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
    const invoiceList = existingInvoices.data?.data || [];
    const fullInvoiceNo = `${prefix}${invoiceNo}`.trim();

   const gstNumber = localStorage.getItem("gstNumber");
// const fullInvoiceNo = `${prefix}${invoiceNo}`.trim();

const invoiceExists = invoiceList.some(inv =>
  inv.InvoiceNumber === fullInvoiceNo &&
  inv._id !== id &&
  inv.GSTNumber === gstNumber &&
  personType === "Registered" // ❗ Only block duplicates for Registered users
);

if (invoiceExists) {
  alert(`Invoice Number "${fullInvoiceNo}" already exists for your GST account. Please enter a different one.`);
  return;
}

    const missingFields = [];

    if (personType === "Registered") {
      if (`${prefix}${invoiceNo}`.trim() === '') missingFields.push("Invoice Number");
      if (!invoiceDate) missingFields.push("Invoice Date");
      if (!customerName) missingFields.push("Name");
      if (!gstin) missingFields.push("GSTIN");
      if (!placeOfSupply) missingFields.push("Place of Supply");
      if (grandTotal <= 0) missingFields.push("Total Amount");

      const hasGST = rows.some(
        (row) =>
          (row.CGSTPercentage && row.CGSTPercentage > 0) ||
          (row.SGSTPercentage && row.SGSTPercentage > 0) ||
          (row.IGSTPercentage && row.IGSTPercentage > 0)
      );

      if (!hasGST) {
        missingFields.push("At least one of CGST / SGST / IGST must be filled");
      }

      if (missingFields.length > 0) {
        alert(`Please fill all required fields for Registered Person:\n\n${missingFields.join("\n")}`);
        return;
      }
    }

    if (personType === "Unregistered") {
      if (!customerName) missingFields.push("Name");
      if (!customerAddress) missingFields.push("Customer Address");

      const hasValidProduct = rows.some((row) => {
        const qty = parseFloat(row.qty);
        const rate = parseFloat(row.rate);
        const amount = parseFloat(row.amount);

        return (
          row.productId &&
          !isNaN(qty) && qty > 0 &&
          !isNaN(rate) && rate > 0 &&
          !isNaN(amount) && amount > 0
        );
      });

      if (!hasValidProduct) {
        missingFields.push("At least one valid product with Quantity, Rate, and Amount must be entered");
      }
    }

    if (missingFields.length > 0) {
      alert(`Please correct the following:\n\n${missingFields.join("\n")}`);
      return;
    }

    const payload = {
      InvoiceNumber: `${prefix}${invoiceNo}`,
      InvoiceDate: dayjs(invoiceDate).format("YYYY-MM-DD"),
      StateId: productState,
      StateCode: productStateCode,
      GRNumber: grNo,
      TransportDate: dayjs(transportDate).format("YYYY-MM-DD"),
      VehicleNumber: vehicleNo,
      TranspotationMode: transportationMode,
      TransporterName: transporterName,
      PlaceOfSupply: placeOfSupply,
      CustomerName: customerName,
      CustomerAddress: customerAddress,
      CustomerStateId: customerState,
      CustomerStateCode: customerStateCode,
      GSTNumber: localStorage.getItem("gstNumber"),
      CustomerGSTNumber: gstin,
      SupplierType: personType,
      TotalAmount: grandTotal?.toString(),
      Products: rows.map((row) => ({
        ProductId: row.productId,
        HSNCode: row.hsn,
        Quantity: (!row.qty || isNaN(row.qty)) ? "0" : row.qty.toString(),
        Unit: row.unit,
        Rate: (row.rate === null || row.rate === undefined || row.rate === "" || isNaN(Number(row.rate))) ? "0" : row.rate.toString(),
        Amount: (row.amount === null || row.amount === undefined || row.amount === "" || isNaN(Number(row.amount))) ? "0" : row.amount.toString(),
        CGSTPercentage: row.CGSTPercentage?.toString(),
        SGSTPercentage: row.SGSTPercentage?.toString(),
        IGSTPercentage: row.IGSTPercentage?.toString(),
        CGSTAmount: row.CGSTAmount?.toString(),
        SGSTAmount: row.SGSTAmount?.toString(),
        IGSTAmount: row.IGSTAmount?.toString(),
        OtherCharges: row.otherCharges?.toString() || "0",
        Cess: row.cess?.toString() || "0"
      }))
    };

    console.log(payload);

    if (id) {
      const token = localStorage.getItem("token");

const res = await axios.put(
  `${BASE_URL}/PurchaseInvoice/Update/${id}`,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      alert("Invoice updated successfully");
    } else {
      const token = localStorage.getItem("token");

const res = await axios.post(
  `${BASE_URL}/PurchaseInvoice/Add`,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      alert("Invoice created successfully");
    }

    navigate("/GetPurchaseInvoice");
  } catch (err) {
    console.error("Submit failed:", err);
    alert("Something went wrong");
  }
};


    const amountInWords = convertNumberToWords(totalAmount);

const handleReset = () => {
  setPersonType("Registered"); // Default option
  setInvoiceNo(""); // Empty invoice number
  setPrefix(""); // Empty prefix
  setInvoiceDate(dayjs());
  setProductState(registrationData?.stateName || "");
  setProductStateCode(registrationData?.stateCode || "");
  setGrNo("");
  setTransportDate(dayjs());
  setVehicleNo("");
  setTransportationMode("");
  setTransporterName("");
  setPlaceOfSupply(registrationData?.stateName || "");
  setCustomerName("");
  setCustomerAddress("");
  setGstin(personType === "Unregistered" ? "URP" : "");
  setCustomerState(registrationData?.stateName || "");
  setCustomerStateCode(registrationData?.stateCode || "");
  setRows([{
    id: uuidv4(),
    productId: "",
    hsn: "",
    unit: "",
    qty: "",
    rate: "",
    amount: "",
    gstPercentage: "",
    gstAmount: "",
    totalAmount: "",
    CGSTAmount: "",
    SGSTAmount: "",
    CGSTPercentage: "",
    SGSTPercentage: "",
    IGSTAmount: "",
    IGSTPercentage: "",
    otherCharges: "0.00",
    cess: "0.00",
    taxableAmount: "0.00"
  }]);
  setCgst("");
  setSgst("");
  setIsCgstLocked(false);
  setIsSgstLocked(false);
  setLocalReceiverData({
    firstName: '',
    address: '',
    gstin: '',
    stateName: '',
    stateCode: ''
  });
};

 return (
        <>
            <LayoutUserHeader />
            <Box sx={{ padding: 4 }}>
                <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
                    Add Purchase Invoice
                </Typography>
            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
  <Grid container spacing={2} alignItems="center" justifyContent="center">
    {/* Logo */}
    <Grid item xs={12} sm={3} sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          width: 90,
          height: 90,
          borderRadius: '50%',
          border: '2px solid #ccc',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {registrationData?.companyLogo ? (
          <img
            src={`${BASE_URL}/${registrationData.companyLogo.replace(/\\/g, '/')}`}
            alt="Company Logo"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
            }}
          />
        ) : (
          <Typography variant="caption" color="textSecondary">
            No Image
          </Typography>
        )}
      </Box>
    </Grid>

    {/* Company Info */}
    <Grid item xs={12} sm={9}>
      {registrationData ? (
        <Box>
          {/* Company Name centered */}
          <Typography
            variant="h6"
            sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1 }}
          >
            {registrationData.firmName || 'N/A'}
          </Typography>

          {/* Other details left-aligned */}
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Reg. Address:</strong> {registrationData.address || 'N/A'},
              {' '}
              {registrationData.districtName || 'N/A'},
              {' '}
              {registrationData.stateName || 'N/A'} - {registrationData.pinCode || 'N/A'}
            </Typography>

            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Mobile:</strong> {registrationData.mobileNumber || 'N/A'} &nbsp;&nbsp;
              <strong>Email:</strong> {registrationData.emailId || 'N/A'} &nbsp;&nbsp;
              <strong>GSTIN:</strong> {registrationData.gst || 'N/A'} &nbsp;&nbsp;
              <strong>PAN:</strong> {panNumber || 'N/A'}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Typography variant="body2" color="textSecondary">
          Loading Registration Data...
        </Typography>
      )}
    </Grid>
  </Grid>
</Paper>


                {/* Product/Transport Details */}
                <Paper sx={{ padding: 3, mt: 3 }}>
                   
<Typography
    variant="h6"
    sx={{
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1,backgroundColor: '#fafafa'
    }}
  >
   Invoice / Transport Details
  </Typography>
       <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
 <FormControl component="fieldset">
  <RadioGroup
    row
    value={personType}
    onChange={(e) => {
      const selectedType = e.target.value;

      const confirmMsg =
        selectedType === "Unregistered"
          ? "You are moving to Unregistered Person. All entered data will be cleared. Do you want to continue?"
          : "You are moving to Registered Person. All entered data will be cleared. Do you want to continue?";

      const proceed = window.confirm(confirmMsg);
      if (!proceed) return;

      setPersonType(selectedType);
      setInvoiceNo("");
      setPrefix("");
      setGstin(selectedType === "Unregistered" ? "URP" : "");
      setCustomerName("");
      setCustomerAddress("");
      setCustomerState("");
      setCustomerStateCode("");
      setRows([
        {
          id: uuidv4(),
          productId: "",
          hsn: "",
          unit: "",
          qty: "",
          rate: "",
          amount: "",
          gstPercentage: 0,
          gstAmount: 0,
          CGSTAmount: 0,
          SGSTAmount: 0,
          IGSTAmount: 0,
          CGSTPercentage: 0,
          SGSTPercentage: 0,
          IGSTPercentage: 0,
          otherCharges: "0.00",
          cess: "0.00",
          totalAmount: "0.00",
          taxableAmount: "0.00"
        }
      ]);
    }}
  >
    <FormControlLabel
      value="Registered"
      control={<Radio color="primary" disabled={!!id} />}
      label="Registered Person"
    />
    <FormControlLabel
      value="Unregistered"
      control={<Radio color="primary" disabled={!!id} />}
      label="Unregistered Person"
    />
  </RadioGroup>
</FormControl>

</Box>
  <Box display="flex" justifyContent="space-between" gap={2} mt={3}>
  <Paper elevation={3} sx={{ flex: 1, p: 2, backgroundColor: '#fffdfda6' }}>
    <Typography variant="h6" align="center" fontWeight="bold" sx={{ backgroundColor: '#fafafa', p: 1 }}>
      Invoice Details
    </Typography>
   <Divider sx={{ mb: 2 }} />
                                {id ? (
  // Edit Mode: Read-only field with full invoice number
  <TextField
    label="Invoice No"
    variant="outlined"
    size="small"
    fullWidth
    sx={{ mb: 2 }}
    value={invoiceNo}
    InputProps={{ readOnly: true }}
    placeholder="Invoice No"
  />
) : (
  // Create Mode: Editable prefix, with auto-generated suffix
  <TextField
    label="Invoice No"
    variant="outlined"
    size="small"
    fullWidth
    sx={{ mb: 2 }}
    value={prefix}
    onChange={(e) => setPrefix(e.target.value)}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <strong>{invoiceNo}</strong>
        </InputAdornment>
      ),
    }}
    placeholder={personType === "Registered" ? "Enter invoice no." : "Auto-generated"}
  />
)}
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Invoice Date"
                                        value={invoiceDate}
                                        onChange={(newValue) => setInvoiceDate(newValue)}
                                        format="DD-MM-YYYY"
                                         minDate={financialYearStart}
                                         maxDate={financialYearEnd}
                                        slotProps={{ textField: { size: 'small', sx: { mb: 2 }, fullWidth: true } }}
                                    />
                                </LocalizationProvider>

                                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                    <InputLabel id="product-state-label">State</InputLabel>
                                    <Select
                                        labelId="product-state-label"
                                        value={productState}
                                        label="State"
                                        onChange={(e) => {
                                            const selectedState = stateList.find(s => s.stateName === e.target.value);
                                            setProductState(e.target.value);
                                            setProductStateCode(selectedState?.stateCode || '');
                                        }}
                                    >
                                        <MenuItem value=""><em>Select State</em></MenuItem>
                                        {stateList.map((state) => (
                                            <MenuItem key={state.id} value={state.stateName}>
                                                {state.stateName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <TextField
  label="State Code"
  value={
  typeof productStateCode === 'number'
    ? productStateCode < 10
      ? `0${productStateCode}`
      : `${productStateCode}`
    : productStateCode || '00'
}
  variant="outlined"
  size="small"
  fullWidth
  InputProps={{
    readOnly: true
  }}
/>
  </Paper>

  <Paper elevation={3} sx={{ flex: 1, p: 2, backgroundColor: '#fffdfda6' }}>
    <Typography variant="h6" align="center" fontWeight="bold" sx={{ backgroundColor: '#fafafa', p: 1 }}>
      Transport Details
    </Typography>
   <Divider sx={{ mb: 2 }} />
                                <TextField
                                    label="GR No"
                                    value={grNo}
                                    onChange={(e) => setGrNo(e.target.value)}
                                    variant="outlined"
                                    size="small"
                                    sx={{ mb: 2 }}
                                    fullWidth
                                />
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Transport Date"
                                        value={transportDate}
                                        onChange={(newValue) => setTransportDate(newValue)}
                                        format="DD-MM-YYYY"
                                         minDate={financialYearStart}
                                         maxDate={financialYearEnd}
                                        slotProps={{ textField: { size: 'small', sx: { mb: 2 }, fullWidth: true } }}
                                    />
                                </LocalizationProvider>
                                <TextField
                                    label="Vehicle No"
                                    value={vehicleNo}
                                     onChange={(e) => setVehicleNo(e.target.value.toUpperCase())}
                                     onBlur={handleBlur}
                                    variant="outlined"
                                    size="small"
                                    sx={{ mb: 2 }}
                                    fullWidth
                                />
                                {/* <TextField
                                    label="Transportation Mode"
                                    value={transportationMode}
                                    onChange={(e) => setTransportationMode(e.target.value)}
                                    variant="outlined"
                                    size="small"
                                    sx={{ mb: 2 }}
                                    fullWidth
                                /> */}
                                <TextField
  label="Transportation Mode"
  value={transportationMode}
  onChange={(e) => {
    const value = e.target.value;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setTransportationMode(value);
    }
  }}
  variant="outlined"
  size="small"
  sx={{ mb: 2 }}
  fullWidth
/>
                                <TextField
                                    label="Transporter Name"
                                    value={transporterName}
                                    onChange={(e) => setTransporterName(e.target.value)}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            <TextField
                                    label="Place of Supply"
                                    variant="outlined"
                                    size="small"
                                    value={placeOfSupply}
                                    onChange={(e) => setPlaceOfSupply(e.target.value)}
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    required
                                  />
  </Paper>

  {/* Paper 3 */}
  <Paper elevation={3} sx={{ flex: 1, p: 2 }}>
    <Typography variant="h6" align="center" fontWeight="bold" sx={{ backgroundColor: '#fafafa', p: 1 }}>
      Vendor / Purchaser Details
    </Typography>
    <Typography variant="body2" sx={{ mb: 1 }}>
        <TextField
          label="Name"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
        />
    </Typography>
    <Typography variant="body2" sx={{ mb: 1 }}>
         <TextField
          label="Address"
          value={customerAddress}
          onChange={(e) => setCustomerAddress(e.target.value)}
          variant="outlined"
          size="small"
          multiline
          rows={2}
          fullWidth
        />
    </Typography>
    <Typography variant="body2" sx={{ mb: 1 }}>
        <TextField
  label="GSTIN"
  variant="outlined"
  fullWidth
  size="small"
  sx={{ mb: 1 }}
  value={gstin}
  onChange={(e) => handleGstinChange(e.target.value, setGstin, personType)}
  InputProps={{
    readOnly: personType === "Unregistered",
  }}
/>

    </Typography>
    <Typography variant="body2" sx={{ mb: 1 }}>
        <FormControl fullWidth size="small" sx={{ mb: 1 }}>
  <InputLabel id="customer-state-label">State</InputLabel>
  <Select
    labelId="customer-state-label"
    value={customerState}
    label="State"
    onChange={(e) => {
      const selectedState = stateList.find(s => s.stateName === e.target.value);
      setCustomerState(e.target.value);
      setCustomerStateCode(
        selectedState?.stateCode
          ? parseInt(selectedState.stateCode) < 10
            ? `0${selectedState.stateCode}`
            : `${selectedState.stateCode}`
          : "Not Available"
      );
    }}
  >
    <MenuItem value=""><em>Select State</em></MenuItem>
    {stateList.map((state) => (
      <MenuItem key={state.id} value={state.stateName}>
        {state.stateName}
      </MenuItem>
    ))}
  </Select>
</FormControl>
    </Typography>
    <Typography variant="body2" sx={{ mb: 1 }}>
    <TextField
  label="State Code"
  value={String(customerStateCode).padStart(2, '0')}
  variant="outlined"
  size="small"
  fullWidth
  InputProps={{ readOnly: true }}
/>
    </Typography>
    
    
    <Button
  variant="contained"
  startIcon={<SaveIcon />}
  size="small"
  onClick={async () => {
    if (!customerName || !customerAddress || !customerState) {
      alert("Please fill all required fields before saving.");
      return;
    }

    const gstNumber = localStorage.getItem("gstNumber");

    const payload = {
      name: customerName,
      address: customerAddress,
      gstin: gstin,
      state: customerState,
      stateCode: parseInt(customerStateCode),
      usergstin: gstNumber,
    };

    try {

        console.log(payload);

      const token = localStorage.getItem("token");

const response = await axios.post(
  `${BASE_URL}/ConsigneePurchaseMaster/Add`,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      alert("Saved successfully");
    } catch (error) {
      console.error("Add consignee error:", error);
      toast.error("Failed to save consignee");
    }
  }}
>
  Save To Master Data
</Button>
              <Button
      variant="outlined"
      startIcon={<SaveIcon />}
      size="small"
      onClick={async () => {
        setOpenDialog(true);
        setLoadingConsignees(true);
        try {
          const gstNumber = localStorage.getItem("gstNumber");
    
          const response = await fetch(`${BASE_URL}/ConsigneePurchaseMaster/GetAll`);
          
          const data = await response.json();
          console.log(data);
		
    const filteredConsignees = data.data?.filter((item) => {
  const isURP = item.gstin === "URP" || item.gstin === "";
  const isMatchingType = personType === "Unregistered" ? isURP : !isURP;
  return item.usergstin === gstNumber && isMatchingType;
}) || [];

    console.log("Filtered Consignees:", filteredConsignees);
    
      setConsigneeList(filteredConsignees);
    
        } catch (error) {
          console.error('Error fetching consignee data:', error);
        } finally {
          setLoadingConsignees(false);
        }
      }}
      sx={{ ml: 2 }}
    >
      Load From Master Data
    </Button>
    {openDialog && (
  <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
    <DialogTitle>Select Consignee</DialogTitle>
    <DialogContent>
      {loadingConsignees ? (
        <Typography>Loading...</Typography>
      ) : (
        <Box>
          {consigneeList.map((consignee) => (
            <Paper
              key={consignee.id}
              onClick={() => handleConsigneeSelect(consignee)}
              sx={{ p: 2, mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f0f0f0' } }}
            >
              <Typography variant="subtitle1">{consignee.name}</Typography>
              <Typography variant="body2">{consignee.address}</Typography>
              <Typography variant="body2">GST: {consignee.gstin}</Typography>
              <Typography variant="body2">
              {consignee.state} | Code: {String(consignee.stateCode).padStart(2, '0')}
              </Typography>
            </Paper>
          ))}
        </Box>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setOpenDialog(false)}>Close</Button>
    </DialogActions>
  </Dialog>
)}
  </Paper>
</Box>
                   
                </Paper>


               
                {/* Purchase Invoice Details */}
                <Paper sx={{ padding: 3, mt: 3, mb: 3 }}>
                   
                    <Typography
    variant="h6"
    sx={{
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1,backgroundColor: '#fafafa'
    }}
  >
    Purchase Invoice Details
  </Typography>
  <TableContainer component={Paper} sx={{ border: "1px solid #ccc" }}>
  <Table size="small">
    <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
  <TableRow>
    <TableCell align="center">S.No</TableCell>
    <TableCell align="center">Name of Product</TableCell>
    <TableCell align="center">HSN Code</TableCell>
    <TableCell align="center">QTY</TableCell>
    <TableCell align="center">Unit</TableCell>
    <TableCell align="center">Rate</TableCell>
        <TableCell align="center">Taxable Amount</TableCell>
        {isSameState ? (
          <>
            <TableCell align="center">CGST %</TableCell>
            <TableCell align="center">CGST Amt</TableCell>
            <TableCell align="center">SGST %</TableCell>
            <TableCell align="center">SGST Amt</TableCell>
          </>
        ) : (
          <>
            <TableCell align="center">IGST %</TableCell>
            <TableCell align="center">IGST Amt</TableCell>
          </>
        )}

    <TableCell align="center">Other Charges</TableCell>
    <TableCell align="center">Cess</TableCell>
    <TableCell align="center">Total Amount</TableCell>
    <TableCell align="center">Action</TableCell>
  </TableRow>
</TableHead>
 <TableBody>
  {rows.map((row, index) => (
    <TableRow key={row.id}>
      <TableCell align="center">{index + 1}</TableCell>

      <TableCell align="center">
        <FormControl variant="standard" fullWidth>
          <Select
            value={row.productId}
            onChange={(e) => handleProductChange(row.id, e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select Product
            </MenuItem>
            {productList.map((product) => (
              <MenuItem key={product.id} value={product.id}>
                {product.ProductName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </TableCell>

      <TableCell align="center">
        <TextField
          variant="standard"
          value={row.hsn || ""}
          onChange={(e) => handleInputChange(row.id, "hsn", e.target.value)}
          sx={{ width: 100 }}
        />
      </TableCell>

      <TableCell align="center">
        <TextField
          variant="standard"
          type="number"
          value={row.qty}
          onChange={(e) => handleInputChange(row.id, "qty", e.target.value)}
          sx={{ width: 60 }}
        />
      </TableCell>

      <TableCell align="center">
        <Typography>{row.unit || "-"}</Typography>
      </TableCell>

      <TableCell align="center">
        <TextField
          variant="standard"
          type="number"
          value={row.rate}
          onChange={(e) => handleInputChange(row.id, "rate", e.target.value)}
          sx={{ width: 60 }}
        />
      </TableCell>

         {/* <TableCell align="center">
<TextField
  variant="standard"
  type="number"
  value={row.amount?.toString() || ""}
  onChange={(e) => handleInputChange(row.id, "amount", e.target.value)}
  inputProps={{
      readOnly:
        personType !== "Registered" ||
        row.productId !== "" 
    }}
  sx={{ width: 80 }}
/>
</TableCell> */}

<TableCell align="center">
  <TextField
    variant="standard"
    type="number"
    value={row.taxableAmount ?? ""}
    onChange={(e) => handleInputChange(row.id, "taxableAmount", e.target.value)}
    inputProps={{
      readOnly: personType !== "Registered", // editable only for Registered
      step: "0.01",
    }}
    sx={{ width: 100 }}
  />
</TableCell>

          {isSameState ? (
            <>
              <TableCell align="center">
  <TextField
    variant="standard"
    type="number"
    value={row.CGSTPercentage || ""}
    onChange={(e) =>
      handleInputChange(row.id, "CGSTPercentage", e.target.value)
    }
    sx={{ width: 80 }}
    inputProps={{
      readOnly:
        personType !== "Registered" ||
        row.productId !== "" || // Disable if product is selected
        row.__lockedBy === "SGST",
    }}
  />
</TableCell>

              <TableCell align="center">
                <TextField
                  variant="standard"
                  type="number"
                  value={row.CGSTAmount || ""}
                  onChange={(e) =>
                    handleInputChange(row.id, "CGSTAmount", e.target.value)
                  }
                  sx={{ width: 80 }}
                />
              </TableCell>
              <TableCell align="center">
  <TextField
    variant="standard"
    type="number"
    value={row.SGSTPercentage || ""}
    onChange={(e) =>
      handleInputChange(row.id, "SGSTPercentage", e.target.value)
    }
    sx={{ width: 80 }}
    inputProps={{
      readOnly:
        personType !== "Registered" ||
        row.productId !== "" || // Disable if product is selected
        row.__lockedBy === "CGST",
    }}
  />
</TableCell>

              <TableCell align="center">
                <TextField
                  variant="standard"
                  type="number"
                  value={row.SGSTAmount || ""}
                  onChange={(e) =>
                    handleInputChange(row.id, "SGSTAmount", e.target.value)
                  }
                  sx={{ width: 80 }}
                />
              </TableCell>
            </>
          ) : (
            <>
              <TableCell align="center">
  <TextField
    variant="standard"
    type="number"
    value={row.IGSTPercentage || ""}
    onChange={(e) =>
      handleInputChange(row.id, "IGSTPercentage", e.target.value)
    }
    sx={{ width: 80 }}
    inputProps={{
      readOnly:
        personType !== "Registered" ||
        row.productId !== "", // lock if product is selected
    }}
  />
</TableCell>

              <TableCell align="center">
              <TextField
  		variant="standard"
 		 type="number"
 		 value={row.IGSTAmount || ""}
		  InputProps={{ readOnly: true }}
		  sx={{ width: 80 }}
		/>

              </TableCell>
            </>
          )}

      <TableCell align="center">
        <TextField
          variant="standard"
          type="number"
          value={row.otherCharges || ""}
          onChange={(e) =>
            handleInputChange(row.id, "otherCharges", e.target.value)
          }
          sx={{ width: 60 }}
        />
      </TableCell>
      <TableCell align="center">
        <TextField
          variant="standard"
          type="number"
          value={row.cess || ""}
          onChange={(e) => handleInputChange(row.id, "cess", e.target.value)}
          sx={{ width: 60 }}
        />
      </TableCell>

     <TableCell align="center">
  <TextField
    variant="standard"
    type="number"
    value={
      row.totalAmount !== undefined && row.totalAmount !== null
        ? row.totalAmount.toString()
        : ""
    }
    InputProps={{ readOnly: true }}
    sx={{ width: 80 }}
  />
</TableCell>



      <TableCell align="center">
        <Button
          size="small"
          variant="outlined"
          onClick={addRow}
          color="success"
        >
          +
        </Button>
        {rows.length > 1 && (
          <Button
            size="small"
            variant="outlined"
            onClick={() => removeRow(row.id)}
            color="error"
            sx={{ ml: 1 }}
          >
            -
          </Button>
        )}
      </TableCell>
    </TableRow>
  ))}
</TableBody>
    
  </Table>
</TableContainer>
                   
                </Paper>
                <Paper sx={{ padding: 3, mb: 3 }}>
                 
      <Typography
    variant="h6"
    sx={{
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1,backgroundColor: '#fafafa'
    }}
  >
    Conditions / Signature
  </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} sx={{ border: '1px solid #ccc', p: 2, width: '48%' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Terms And Conditions
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                Certified that particulars given above are true and correct.
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                Subject To {registrationData?.districtName || 'N/A'} jurisdiction Only.
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                E & OE
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={6} sx={{ border: '1px solid #ccc', p: 2, width: '48%' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Authorised Signatory
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                             <Typography variant="body2" sx={{ mb: 1, textAlign: 'center' }}>
                               <strong>For, {registrationData?.firmName || 'N/A'} </strong>
                              </Typography>

                            <Box sx={{ height: 50, textAlign: "center" }} />
                            <Typography variant="body2" sx={{ textAlign: "center" }} >
                                <strong>Authorised Signatory</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>


                <Box sx={{ textAlign: "center", mt: 3 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                    >   {id ? "Update" : "Submit"}  </Button>
		<Button
        type="button"
        variant="outlined"
        color="secondary"
        onClick={handleReset}
        style={{ marginLeft: 8 }}
    >
        Reset
    </Button>

                </Box>
            </Box>
        </>
    );


};

export default AddPurchaseInvoice;

 
